import axios from 'axios';
import { getRealPath } from '@/utils/utils';
import { responseHandle } from '@/utils/responseHandle';
import qs from 'qs';
import { compatibleConfig } from '@/utils/compatible';
import { Notification } from '@hs/hanshow-ui';

import i18n from "@/i18n/index";
import { getToken } from '@/utils/auth';
import store from '@/store';
import jsonBig from 'json-bigint';

//兼容配置选项
compatibleConfig();
let getaway = (window.__POWERED_BY_QIANKUN__ && store) ? store.state.global.props.gateway : '';
const service = axios.create({
    baseURL: process.env.NODE_ENV == 'development' ? (window.__POWERED_BY_QIANKUN__ ? '/proxy/prismart' : '/api/') : getRealPath(getaway), // url = base url + request url
    withCredentials: true,
    transformResponse: [function (data, headers) {
        try {
            // 如果转换成功则返回转换的数据结果
            if (headers['content-type'].includes('application/json')) {
                return jsonBig.parse(data);
            } else {
                return data;
            }
        } catch (err) {
            // 如果转换失败，则包装为统一数据格式并返回
            return {
                data
            };
        }
    }],
    paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
    }
});
service.interceptors.request.use(
    config => {
        const requestBody = {};
        if (getToken()) {
            config.headers.common['csrftoken'] = getToken();
        }
        if (config.method.toUpperCase() === 'GET') {
            config.paramsSerializer = function (params) {
                const serializedParams = {};
                for (const key in params) {
                    if (Object.prototype.hasOwnProperty.call(params, key)) {
                        if (params[key] === null) {
                            serializedParams[key] = null; // 保持 null 值
                        } else if (typeof params[key] === 'object' && !Array.isArray(params[key])) {
                            serializedParams[key] = JSON.stringify(params[key]);
                        } else {
                            serializedParams[key] = params[key];
                        }
                    }
                }

                // 使用 qs 库来处理数组和其他参数的序列化
                return qs.stringify(serializedParams, { arrayFormat: 'repeat', encodeValuesOnly: true });
                // return qs.stringify(params, { arrayFormat: 'repeat', encodeValuesOnly: true });
            };
            requestBody.params = config.data;
            config.params = requestBody.params;
        }
        if (config.headers['PS-AUDIT-PERMISSION-CODE']) {
            let code = window.HS_CONST.permissionMap[config.headers['PS-AUDIT-PERMISSION-CODE']];
            config.headers['PS-AUDIT-PERMISSION-CODE'] = code;
        }

        if (window.__POWERED_BY_QIANKUN__) {
            const accessToken = store.state.global ? store.state.global.props.getGlobalState('accessToken') : '';
            if (store.state.global && accessToken) {
                config.headers.common['Authorization'] = 'Bearer ' + accessToken;
                return config;
            } else {
                store.dispatch('user/logoutClear', {});
            }
        } else {
            return config;
        }
    }
);

service.interceptors.response.use(response => {
    if (response.headers['content-type'].includes('application/octet-stream')) {
        return response;
    } else {
        responseHandle(response.data);
        return response.data;
    }
}, error => {
    const { response } = error;
    let message = 'promptMessage.axiosError';
    if (response && response.status === 401 && response.data.resultCode == 'C0102') {
        store.dispatch('user/logoutClear', {});
        message = 'promptMessage.error1007';
    }
    Notification.closeAll();
    Notification.error({
        showClose: true,
        message: i18n.t(message),
        type: 'error'
    });
    return Promise.reject(error);
});

function resetBaseUrl() {
    const getaway = (window.__POWERED_BY_QIANKUN__ && store) ? store.state.global.props.gateway : '';
    const url = process.env.NODE_ENV == 'development' ? (window.__POWERED_BY_QIANKUN__ ? '/proxy/prismart' : '/api/') : getRealPath(getaway);
    service.defaults.baseURL = url;
}


export default service;
export {
    resetBaseUrl
};
